import axios from "axios";
import { motion } from "framer-motion";
import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import "react-image-lightbox/style.css";
import { useParams } from "react-router-dom";
import VisibilitySensor from "react-visibility-sensor";
import { Context } from "../../context";
import classes from "./Demo.module.css";
import DemoCard from "./DemoCard";
const url = "https://demo-api.davidebalice.dev/api/demos?limit=7";

const DemoDetailsOther = ({ id }) => {
  const [demoData, setDemoData] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const { debug, lang } = useContext(Context);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const [filteredData, setFilteredData] = useState([]);
  const { slug } = useParams();
  let delay = 0;

  const getData = async () => {
    try {
      const response = await axios.get(url);
      const filtered = response.data.demos.filter((item) => item.slug !== slug);
      console.log("filtered");
      console.log(filtered);
      setFilteredData(filtered);
      setDemoData(response.data.demos);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className={classes.demoHome}>
        <Container fluid className="text-center pb-5 pt-5">
          {filteredData && filteredData.length > 0 && (
            <VisibilitySensor
              onChange={changeVisibility}
              partialVisibility
              delayedCall
            >
              <motion.p
                initial={{ opacity: 0, y: 12 }}
                animate={{
                  opacity: isVisible ? 1 : 0,
                  y: isVisible ? 0 : 20,
                }}
                transition={{ duration: 0.4, delay: 0.2 }}
                className="text-7 text-dark w-100 align-self-center lh-base mb-1 mt-5"
              >
                Other Demo
                {lang === "en" && <></>}
                {lang === "it" && <></>}
              </motion.p>
            </VisibilitySensor>
          )}

          <Container
            fluid
            className={`${classes.demoCardContainer} text-center pb-5 pt-5`}
          >
            <div className="row gx-3 mx-lg-4 portfolio">
              {filteredData &&
                filteredData.length > 0 &&
                filteredData
                  .sort((a, b) => a.order - b.order)
                  .slice(0, 6)
                  .map((el) => {
                    /*
                    if (el.id === filteredData.id) {
                      return null;
                    }*/
                    delay = delay + 0.2;
                    return <DemoCard key={el.title} {...el} delay={delay} />;
                  })}
            </div>
          </Container>
        </Container>
      </div>
    </>
  );
};

export default DemoDetailsOther;
